import AddManufacturer from "./AddManufacturer";

export default AddManufacturer;
